import {
  faUser,
  faSort,
  faSortUp,
  faSortDown,
  faSync,
  faEye,
  faBan,
  faTimes,
  faArrowLeft,
  faSave,
  faPlus,
  faPencilAlt,
  faBars,
  faThList,
  faUserPlus,
  faRoad,
  faTachometerAlt,
  faHeart,
  faList,
  faBell,
  faBook,
  faHdd,
  faFlag,
  faWrench,
  faLock,
  faCloud,
  faSignOutAlt,
  faSignInAlt,
  faCalendarAlt,
  faSearch,
  faTrashAlt,
  faAsterisk,
  faTasks,
  // jhipster-needle-add-icon-import
  faHome,
  faChevronLeft,
  faChevronRight,
  faGlobe,
  faEuroSign,
  faFileContract,
  faAddressCard,
  faMailBulk,
  faPlay,
  faRulerHorizontal,
  faMinusCircle,
  faCreditCard,
  faBarcode,
  faMapMarker,
  faCheck,
  faIndustry,
  faHandshake,
  faCoffee,
  faPencilRuler,
  faTrash,
  faArrowRight,
  faArrowDown,
  faDoorOpen,
  faCogs,
  faClock,
  faKey,
  faBookOpen,
  faUsers,
  faTools,
  faWallet,
  faReceipt,
  faFileArrowDown,
  faFilter,
  faFileImage,
} from '@fortawesome/free-solid-svg-icons';

import {
  faClock as farClock,
  faUser as farUser,
  faSquare as farSquare,
  faCheckSquare as farCheckSquare,
  faCalendar as farCalendar,
} from '@fortawesome/free-regular-svg-icons';

export const fontAwesomeIcons = [
  faUser,
  farUser,
  faSort,
  faSortUp,
  faSortDown,
  faSync,
  faEye,
  faBan,
  faTimes,
  faArrowLeft,
  faSave,
  faPlus,
  faPencilAlt,
  faBars,
  faHome,
  faThList,
  faUserPlus,
  faRoad,
  faTachometerAlt,
  faHeart,
  faList,
  faBell,
  faTasks,
  faBook,
  faHdd,
  faFlag,
  faWrench,
  faLock,
  faCloud,
  faSignOutAlt,
  faSignInAlt,
  faCalendarAlt,
  faSearch,
  faTrashAlt,
  // jhipster-needle-add-icon-import
  faAsterisk,
  faChevronLeft,
  faChevronRight,
  faGlobe,
  faEuroSign,
  faFileContract,
  faAddressCard,
  faMailBulk,
  faPlay,
  faRulerHorizontal,
  faMinusCircle,
  faCreditCard,
  faBarcode,
  faMapMarker,
  faCheck,
  faIndustry,
  faHandshake,
  faCoffee,
  faPencilRuler,
  faTrash,
  faArrowRight,
  faArrowDown,
  faDoorOpen,
  faCogs,
  faClock,
  farClock,
  faKey,
  faBookOpen,
  faUsers,
  faTools,
  faWallet,
  faReceipt,
  farSquare,
  farCheckSquare,
  faFileArrowDown,
  faFilter,
  faFileImage,
  farCalendar,
];
